namespace SolovisGateway.Admin.Authentication {

    /**
     * JwtAuthAppsListControl presents the user interface for administrating JWT Auth Apps.
     */
    export class JwtAuthAppsListControl extends Solovis.UI.BaseControl {

        private _jwtAuthApps: Array<JwtAuthAppModel>;
        private _allUsers: Array<JwtAuthAppUserModel>;
        private _initError;

        private _dataGrid: DevExpress.ui.dxDataGrid;
        private _gridHelper: Solovis.DevExtreme.DxDataGridHelper;

        constructor(options) {
            super(options);
            this._jwtAuthApps = new Array<JwtAuthAppModel>();
            this._allUsers = new Array<JwtAuthAppUserModel>();
        }

        public async doInitAsync() {
            let self = this;

            let users = await Solovis.Rpc.invoke(
                "~/Admin/UserAdmin/GetUsers",
                {},
                function (response, success) {
                    if (success
                        && response
                        && response.result
                        && response.result.users) {

                        response.result.users.forEach(user => {
                            let model = new JwtAuthAppUserModel(user);
                            self._allUsers.push(user);
                        });
                    }
                    else {
                        console.log("ERROR: JwtAuthAppsListControl.doInitAsync");
                        console.log(response.error);
                        self._initError = response.error;
                    }
                }); 

            return await Solovis.Rpc.invoke(
                "~/Rpc/AuthIntegration/GetAllJwtAuthApps",
                {},
                function (response, success) {
                    if (success
                        && response
                        && response.result
                        && response.result.jwtAuthApps) {

                        response.result.jwtAuthApps.forEach(jwtAuthApp => {
                            let model = new JwtAuthAppModel(jwtAuthApp);
                            self._jwtAuthApps.push(model);
                        });
                    }
                    else {
                        console.log("ERROR: JwtAuthAppsListControl.doInitAsync");
                        console.log(response.error);
                        self._initError = response.error;
                    }
                });
        }

        public doRender() {
            let self = this;

            let dataGridContainer = $("<div>").appendTo(this.container);

            let store = new DevExpress.data.ArrayStore({
                key: 'code',
                data: self._jwtAuthApps
            });

            dataGridContainer.dxDataGrid({
                dataSource: {
                    store: store,
                    sort: 'name'
                },

                allowColumnResizing: true,
                allowColumnReordering: true,
                rowAlternationEnabled: true,
                searchPanel: { visible: true },
                columnChooser: { enabled: false },
                editing: {
                    mode: "form",
                    allowDeleting: true,
                    allowAdding: true
                },

                onRowRemoving: self._onRowRemovingHandler,
                onRowInserting: self._onRowInsertingHandler,
                onInitNewRow: self._onInitNewRowHandler,
                onEditorPreparing: self._onEditorPreparingHandler,

                columns: [
                    {
                        dataField: 'name',
                        dataType: 'string',
                        caption: 'Name',
                        validationRules: [{ type: "required" }],
                        allowSorting: true,
                        width: 200,
                        cellTemplate: (container, options) => {
                            let data = <JwtAuthAppModel>options.data;
                            $('<a/>')
                                .text(data.name)
                                .attr("href", Solovis.resolveUrl(`~/Admin/Authentication/JwtAuthApps/Details/${data.code}`))
                                .appendTo(container);
                        }
                    },
                    {
                        dataField: 'code',
                        dataType: 'string',
                        caption: 'Code',
                        validationRules: [{ type: "required" }],
                        allowSorting: true,
                        width: 200
                    },
                    {
                        dataField: 'sharedSigningKey',
                        dataType: 'string',
                        caption: 'Shared Signing Key',
                        validationRules: [{ type: "required" }],
                        visible: false
                    },
                    {
                        dataField: 'jwtPostUrl',
                        dataType: 'string',
                        caption: 'JWT Post URL',
                        validationRules: [{ type: "required" }],
                        visible: false
                    },
                    {
                        dataField: 'isAdvertised',
                        dataType: 'boolean',
                        caption: 'Is Advertised',
                        visible: true,
                        allowSorting: true,
                        width: 125
                    },
                    {
                        dataField: 'isRestricted',
                        dataType: 'boolean',
                        caption: 'Is Restricted',
                        visible: true,
                        allowSorting: true,
                        width: 125
                    },
                    {
                        dataField: 'useAutoLogin',
                        dataType: 'boolean',
                        caption: 'Use Auto Login',
                        visible: true,
                        allowSorting: true,
                        width: 125
                    }
                ]
            });

            this._dataGrid = dataGridContainer.dxDataGrid("instance");
            this._gridHelper = new Solovis.DevExtreme.DxDataGridHelper(this._dataGrid);
        }

        private _onRowRemovingHandler(e: any) {
            let deferred = $.Deferred();
            if (e.data) {
                let data = <JwtAuthAppModel>e.data;
                Solovis.Rpc.invoke(
                    "~/Rpc/AuthIntegration/DeleteJwtAuthApp",
                    data.toDeleteParams(),
                    function (response, success) {
                        if (success) {
                            deferred.resolve();
                        }
                        else {
                            console.log('ERROR: JwtAuthAppsListControl._onRowRemovingHandler');
                            console.log(response.error);
                            deferred.reject(response.error.message);
                        }
                    });
            }

            e.cancel = deferred;
        }

        private _onRowInsertingHandler(e: any) {
            let deferred = $.Deferred();

            if (e.data) {
                let data = new JwtAuthAppModel(e.data);
                Solovis.Rpc.invoke(
                    "~/Rpc/AuthIntegration/AddJwtAuthApp",
                    data.toAddParams(),
                    function (response, success) {
                        if (success) {
                            data.clearSensitiveData();
                            e.data = data;
                            deferred.resolve();
                        }
                        else {
                            console.log('ERROR: JwtAuthAppsListControl._onRowInsertingHandler');
                            console.log(response.error);
                            deferred.reject(response.error.message);
                        }
                    });
            }

            e.cancel = deferred;
        }

        private _onInitNewRowHandler(e: any) {
            JwtAuthAppModel.initializeData(e.data);
        }

        private _onEditorPreparingHandler(e: any) {
            if (e.parentType == "dataRow" && e.dataField == "sharedSigningKey") {
                e.editorOptions.mode = 'password';
            }
        }
    }
}